import {Button } from '@mui/material'
import { makeStyles } from "@mui/styles";
import React from 'react'

const CustomFilledButton = (props) => {
    const useStyles = makeStyles((theme) => ({
        title: {
            "&:hover": {
                backgroundColor: "#00A4FF !important"
            },
            "&:disabled": {
                backgroundColor: "#CCE5FF !important"
            },
            display:'inline-flex !important',
            padding:'8px 24px !important',
            justifyContent:'center !important',
            alignItems:'center !important',
            flexShrink:0,
            minWidth: props.width ? props.width: '150px !important',
            height:'40px !important',
            color: "#fff !important",
            borderRadius:'8px !important', 
            backgroundColor:"#00A4FF !important",
            fontFamily:'inter !important',
            fontSize:'14px !important',
            fontStyle:'normal !important',
            fontWeight:'500 !important',
            lineHeight:'20px !important' ,
                 
        },
    }))
    const { title, prefixIcon, suffixIcon} = props
    const classes = useStyles()
    return (
        <>
            <Button className={classes.title} onClick={props.onBtnClick} disabled={props.disabled}>
              <span style={{verticalAlign:'middle',alignItems:'center',marginRight:'5px',paddingTop:'2px',fontFamily:'inter'}}>{prefixIcon}</span>
             <span style={{fontFamily:'inter'}}> {title}</span>  
              <span style={{verticalAlign:'middle',alignItems:'center',marginLeft:'5px',paddingTop:'4px'}}>{suffixIcon}</span>
            </Button>
        </>
    )
}
export default CustomFilledButton